<section class="section-main-padding">
    <h1 class="page-title">Term & Condition</h1>
    <p>
        These Terms and Conditions, along with privacy policy or other terms (“Terms”) constitute a binding agreement by
        and between <span class="text-herbs">Herbs.</span><span class="text-lyf">LYF<sup>®</sup></span> HEALTHCARE PRODUCTS, ( “Website Owner” or “we” or “us” or “our”) and you (“you” or
        “your”) and relate to your use of our website, goods (as applicable) or services (as applicable) (collectively,
        “Services”).
    </p>
    <p>By using our website and availing the Services, you agree that you have read and accepted these Terms (including
        the Privacy Policy). We reserve the right to modify these Terms at any time and without assigning any reason. It
        is your responsibility to periodically review these Terms to stay informed of updates.
    </p>
    <p>The use of this website or availing of our Services is subject to the following terms of use:</p>

    <ul>
        <li>You agree to provide true, accurate, and complete information during and after registration and are
            responsible for all actions taken using your registered account.</li>
        <li>Neither we nor any third parties provide warranties or guarantees regarding the accuracy, timeliness,
            performance, completeness, or suitability of the information and materials on the website or through the
            Services for any specific purpose.</li>
        <li>You acknowledge that the information and materials may contain inaccuracies or errors, and we expressly
            exclude liability for such inaccuracies or errors to the fullest extent permitted by law.</li>
        <li>Your use of the Services and the website is at your own risk and discretion, and you are required to
            independently ensure that the Services meet your requirements.</li>
        <li>The contents of the Website and the Services are proprietary to us, and you will not have any authority to
            claim intellectual property rights, title, or interest in its contents.</li>
        <li>Unauthorized use of the Website or Services may lead to action against you as per these Terms or applicable
            laws.</li>
        <li>You agree to pay the charges associated with availing the Services.</li>
        <li>You agree not to use the website and/or Services for any unlawful, illegal, or forbidden purpose under these
            Terms or applicable Indian or local laws.</li>
        <li>You acknowledge that the website and the Services may contain links to third-party websites, and upon
            accessing these links, you will be governed by the terms of use, privacy policy, and other policies of such
            third-party websites.</li>
        <li>You understand that initiating a transaction for availing the Services constitutes entering into a legally
            binding and enforceable contract with us for the Services.</li>
        <li>You are entitled to claim a refund for the payment made if we are unable to provide the Service. Refund
            timelines will adhere to specific Service policies or our policies (as applicable). Failure to raise a
            refund claim within the stipulated time will render you ineligible for a refund.</li>
        <li>Neither party shall be liable for failure to perform obligations under these Terms if prevented or delayed
            by a force majeure event.</li>
        <li>These Terms and any related disputes or claims shall be governed by the laws of India.</li>
        <li>All disputes arising out of or in connection with these Terms shall fall under the exclusive jurisdiction of
            the courts in Gautam Buddha Nagar, Uttar Pradesh.</li>
        <li>All concerns or communications related to these Terms must be directed to us using the contact information
            provided on this website.</li>
    </ul>

</section>